import { render, staticRenderFns } from "./ad-set-list.vue?vue&type=template&id=5922bea8"
import script from "./ad-set-list.vue?vue&type=script&lang=js"
export * from "./ad-set-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports